import { AxiosError } from "axios";
import { UseQueryOptions, useQuery } from "react-query";
import { compareAsc } from "date-fns";

import { axios } from "utilities/axios";
import { IAnomalyEvent, IAnomalyEventsGetResponse, Route } from "@edgetier/watchtower-types";
import { showServerError } from "utilities/show-server-error";

/**
 * Get all anomaly events for an anomaly.
 * @param url URL to get anomaly events.
 */
const getAnomalyEvents = async (url: string) => {
    const response = await axios.get<IAnomalyEventsGetResponse>(url);
    return response.data.items.sort((eventOne, eventTwo) => compareAsc(eventOne.startDateTime, eventTwo.startDateTime));
};

/**
 * Get anomaly events for an anomaly.
 * @param anomalyId Anomaly events belong to an anomaly.
 * @returns         React Query result.
 */
const useAnomalyEvents = (
    anomalyId: string,
    configuration: UseQueryOptions<IAnomalyEvent[], AxiosError<void>> = {}
) => {
    const url = Route.AnomalyEvents.replace(":anomalyId", anomalyId);
    return useQuery<IAnomalyEvent[], AxiosError<void>>(url, () => getAnomalyEvents(url), {
        onError: showServerError,
        ...configuration,
    });
};

export default useAnomalyEvents;
